import * as React from 'react';

import DeliverableMediaForInsights from 'modules/deliverables/components/media/parts/media-for-insights/DeliverableMediaForInsights';
import DeliverableSubHeader from '../../deliverable-sub-header/DeliverableSubHeader';
import Input from 'components/inputs/input/Input';

import { DELIVERABLE_ATTACHMENT_TYPE_HIGHRES } from 'utils/deliverables';
import { __t, applyTranslations } from 'utils/language';

import { Deliverable, DeliverablePost } from 'types';

import './deliverable-post-url.scss';

applyTranslations(require('./deliverable-post-url.i18n.json'));

type Props = {
  deliverable: Deliverable,
  deliverablePost?: DeliverablePost,
  isEditMode: boolean,
  postUrl?: string,
  postUrlError: string,
  isForBrand?: boolean,
  onSetPostUrl: (value: string) => void,
  onSetEditMode: () => void,
  onDeleteUrl: () => void,
  onEditUrl: () => void
}

const msgKey = 'deliverable_post_url';

const DeliverablePostUrl = ({
  postUrl,
  isEditMode,
  deliverable,
  postUrlError,
  isForBrand,
  onSetPostUrl,
  onSetEditMode,
  onDeleteUrl,
  onEditUrl,
  deliverablePost
}: Props) => {
  const { id, deliverableType } = deliverable;

  return (
    <React.Fragment>
      <DeliverableSubHeader
        title={__t(`${msgKey}.channels.${deliverableType}.header`)}
        instruction={isEditMode &&
          __t(`${msgKey}.channels.${deliverableType}.instruction.${isForBrand ? 'brand' : 'influencer'}`)}
        directon={(isEditMode || postUrl) ? 'column' : 'row'}
        emptyNote={(isEditMode || postUrl) ? '' : __t(`${msgKey}.url_empty_note`)}
      />
      {
        isEditMode && !(deliverablePost && postUrl) && (
          <div className="deliverable-post-url__input-container">
            <Input
              width="responsive"
              name={`${id}-post-url`}
              placeholder={__t(`${msgKey}.channels.${deliverableType}.url`)}
              value={postUrl || ''}
              onChange={(event) => onSetPostUrl(event?.target?.value)}
              className={postUrlError ? 'deliverable-post-url__error-input' : ''}
            />
            {
              postUrlError && (
                <div className="deliverable-post-url__error-message">
                  {postUrlError}
                </div>
              )
            }
          </div>
        )
      }
      {
        postUrl && deliverablePost && (
          <div className="deliverable-post-url__media-container">
            <DeliverableMediaForInsights
              attachment={{
                id: deliverablePost.id,
                externalUrl: deliverablePost.url,
                url: deliverablePost.thumbnailUrl ?? deliverablePost.url,
                assetType: 'image',
                fileName: deliverablePost.url,
                meta: {
                  type: DELIVERABLE_ATTACHMENT_TYPE_HIGHRES
                }
              }}
              isEditMode={isEditMode}
              deliverable={deliverable}
              onEditModeToggled={onSetEditMode}
              isPost
              onDeleteUrl={onDeleteUrl}
              onEditUrl={onEditUrl}
            />
          </div>
        )
      }
    </React.Fragment>
  );
};

export default DeliverablePostUrl;
